(function () {
	angular
		.module('trackeye')
		.factory('FlexEvent', _FlexEventFactory);

	_FlexEventFactory.$inject = ['AppFactory'];

	function _FlexEventFactory(AppFactory) {

		function FlexEvent(data, device, options) {
			this.uuid = undefined;

			this.active = undefined;
			this.weekdays = undefined;
			this.periodfrom = undefined;
			this.periodto = undefined;
			this.type = undefined;
			this.high = true;
			this.low = true;

			this.c4api_id = undefined;

			//this.activefrom = undefined;
			//this.activeto = undefined;
			this.text = undefined;
			//this.delay = undefined;

			this.locale = undefined;
			this.measure_port = undefined;
			this.min_distance = undefined;
			this.max_distance = undefined;
			this.min_temp = undefined;
			this.max_temp = undefined;
			this.min_humid = undefined;
			this.max_humid = undefined;
			this.moved_distance = undefined;

			this.template_id = AppFactory.getAppEventhandlerTemplateId();
			this.product = AppFactory.getAppEventhandlerProduct();
			this.sender = AppFactory.getAppEventhandlerSender(),
			//this.eventHandlerHasCallbackUrl = [];
			this.eventHandlerHasEmail = [{
				template: this.template_id,
				sender: this.sender,
				recipient: "",
				subject: ""
			}];
			//this.eventHandlerHasSms = [];

			this.device = device;

			this.weekdays_bitmask = {"mon": 0, "tue": 1, "wed": 2, "thu": 3, "fri": 4, "sat": 5, "sun": 6};
			if (data) {
				this.populate(data, options || {});
			}
		}

		FlexEvent.prototype.getText = function () {
			return this.text;
		}

		FlexEvent.prototype.isActive = function () {
			return this.active;
		};

		FlexEvent.prototype.isPeriodValid = function () {
			if (!this.hasPeriod()) {
				return true;
			}

			return validatePeriod(this.periodfrom) && validatePeriod(this.periodto)
		}

		FlexEvent.prototype.hasPeriod = function () {
			return !!(this.periodfrom && this.periodto);
		};

		FlexEvent.prototype.getPeriodFrom = function () {
			if (!this.periodfrom)
				return null;

			return getMomentFromHM(this.periodfrom);

		};

		FlexEvent.prototype.getPeriodTo = function () {
			if (!this.periodto)
				return null;

			return getMomentFromHM(this.periodto);
		};

		FlexEvent.prototype.getPeriodFromAsFlexHMS = function () {
			if (!this.hasPeriod())
				return null;

			var period = getMomentFromHM(this.periodfrom).utc()
			return lpad(period.hours()) + "" + lpad(period.minutes()) + "00";
		};

		FlexEvent.prototype.getPeriodToAsFlexHMS = function () {
			if (!this.hasPeriod())
				return null;

			var period = getMomentFromHM(this.periodto).utc()
			return lpad(period.hours()) + "" + lpad(period.minutes()) + "00";
		};

		FlexEvent.prototype.hasUuid = function () {
			return !!this.getUuid();
		};

		FlexEvent.prototype.getUuid = function () {
			return this.uuid;
		};

		FlexEvent.prototype.hasMinMaxDistance = function() {
			return this.min_distance && this.max_distance && (this.type == 103 || this.type == 104);
		}

		FlexEvent.prototype.getMinDistance = function () {
			if (!this.device) {
				return undefined;
			}
			return this.device.features.calcDistanceAna(this.min_distance) || undefined;
		};

		FlexEvent.prototype.getMaxDistance = function () {
			if (!this.device) {
				return undefined;
			}
			return this.device.features.calcDistanceAna(this.max_distance) || undefined;
		};

		FlexEvent.prototype.getMeasurePort = function () {
			return this.measure_port || undefined;
		};

		FlexEvent.prototype.getMinTemperature = function () {
			return isNaN(this.min_temp) ? undefined : parseInt(this.min_temp, 10);
		};

		FlexEvent.prototype.getMaxTemperature = function () {
			return isNaN(this.max_temp) ? undefined : parseInt(this.max_temp, 10);
		};

		FlexEvent.prototype.getMinHumidity = function () {
			return isNaN(this.min_humid) ? undefined : parseInt(this.min_humid, 10);
		};

		FlexEvent.prototype.getMaxHumidity = function () {
			return isNaN(this.max_humid) ? undefined : parseInt(this.max_humid, 10);
		};

		FlexEvent.prototype.hasTemperatures = function () {
			return this.max_temp && this.min_temp && (this.type == 81); // TODO: Need to define temperature for i2c type:141
		};

		FlexEvent.prototype.hasHumidity = function () {
			return this.max_humid && this.min_humid && (this.type == 142);
		};

		FlexEvent.prototype.getMovedDistance = function () {
			return isNaN(this.moved_distance) ? undefined : parseInt(this.moved_distance * 1000, 10);
		};

		FlexEvent.prototype.hasMovedDistance = function () {
			return angular.isDefined(this.moved_distance) && (this.type == 94);
		};

		FlexEvent.prototype.isWeekdaySet = function (day) {
			if (typeof day === "string")
				return this.weekdays & 1 << this.weekdays_bitmask[day];

			if (typeof day === "number")
				return this.weekdays & 1 << day;
		};

		FlexEvent.prototype.getWeekdays = function () {
			return this.weekdays || null;
		};

		FlexEvent.prototype.toggleWeekday = function (day) {
			this.weekdays ^= 1 << this.weekdays_bitmask[day];
		};

		/**
		 * Assert if there's any reciepients in the eventHandlerHasEmail array
		 * @return {boolean}
		 */
		FlexEvent.prototype.hasRecipients = function () {
			if (this.eventHandlerHasEmail.length <= 0)
				return false;

			for (var i = 0; i < this.eventHandlerHasEmail.length; i++) {
				if (!!this.eventHandlerHasEmail[i].recipient)
					return true;
			}

			return false;
		};

		FlexEvent.prototype.getEventHandlerHasEmail = function () {
			var self = this;
			return this.eventHandlerHasEmail.map(function (value) {
				value.template = self.template_id;
				value.sender = self.sender;
				value.subject = "";
				return value;
			});
		};

		FlexEvent.prototype.getRecipients = function () {
			return this.eventHandlerHasEmail.map(function (value) {
				return value.recipient;
			});
		};

		FlexEvent.prototype.addEmptyRecipient = function () {
			if (this.eventHandlerHasEmail.length < 4) {
				this.eventHandlerHasEmail.push({
					template: this.template_id,
					sender: this.sender,
					recipient: "",
					subject: "",
				});
			}
		};

		FlexEvent.prototype.removeRecipient = function (idx) {
			this.eventHandlerHasEmail.splice(idx, 1);

			if (this.eventHandlerHasEmail.length <= 0)
				this.addEmptyRecipient();
		};

		/**
		 * List of events, supported by the platform.
		 */
		FlexEvent.prototype.getEventTypeName = function () {
			if (!this.type)
				return undefined;

				var events = [
					{type: 2, name: 'batterylevel'},
					{type: 9, name: 'button1', feature: 20},
					{type: 17, name: 'input2', feature: 41},
					{type: 17, name: 'tamper', feature: 31},
					{type: 30, name: 'gsensor', feature: 29},
					{type: 35, name: 'lightsensor', feature: 30},
					{type: 63, name: 'lost3d'},
					{type: 67, name: 'lost'},
					{type: 73, name: 'nopositions'},
					{type: 81, name: 'temperature', feature: 33},
					{type: 94, name: 'unitmoved'},
					{type: 95, name: 'echotag', feature: 36},
					{type: 96, name: 'changecountry'},
					{type: 97, name: 'accountexpire'},
					{type: 98, name: 'balancetoolow'},
					{type: 103, name: 'distance_below', feature: 34},
					{type: 104, name: 'distance_above', feature: 34},
					{type: 141, name: 'i2c_temperature', feature: 33},
					{type: 142, name: 'i2c_humidity', feature: 33}
				]

			return events.find((function(evt) {
				return evt.type === this.getEventType()
			}).bind(this));
		};

		FlexEvent.prototype.isEventSupported = function () {
			return !!this.getEventTypeName();
		};

		FlexEvent.prototype.getEventType = function () {
			return parseInt(this.type, 10);
		};

		FlexEvent.prototype.getLocale = function () {
			return this.locale;
		};

		FlexEvent.prototype.populate = function (data, options) {
			if (!options) { options = {} }

			for (var key in data) {
				if (this.hasOwnProperty(key)) {
					this[key] = data[key];
					if (!(data instanceof FlexEvent)) {
						if ((['periodfrom','periodto'].indexOf(key) >= 0) && this[key]) {
							this[key] = getLocalHMFromHMS(this[key])
						}
					}
				}
			}

			this.high = !!this.high;
			this.low = !!this.low;

			if (this.moved_distance !== undefined && !isNaN(this.moved_distance)) {
				if (!options.moved_distance_km) {
					this.moved_distance = parseInt(this.moved_distance / 1000, 10)
				}
			}

			if (this.device) {
				this.min_distance = anaToDistance(this.min_distance, this.device.features);
				this.max_distance = anaToDistance(this.max_distance, this.device.features);
			}

			if (this.min_temp || this.max_temp) {
				if (options.temp_is_degrees) {
					this.min_temp = parseInt(this.min_temp, 10);
					this.max_temp = parseInt(this.max_temp, 10);
				} else {
					this.min_temp = parseInt(this.min_temp / 10, 10);
					this.max_temp = parseInt(this.max_temp / 10, 10);
				}
			}

			// Force re-render, to ensure that correct template ID, is set.
			this.eventHandlerHasEmail = this.getEventHandlerHasEmail();
		};

		// FlexEvent.prototype.updateLocalDate = function() {
		// 	if (!this.hasPeriod()) return

		// 	var _from = new Date(),
		// 		_to = new Date();

		// 	_from.setHours(this.periodfrom.getHours())
		// 	_from.setMinutes(this.periodfrom.getMinutes())
		// 	_from.setSeconds(0)
		// 	_from.setMilliseconds(0)
		// 	_to.setHours(this.periodto.getHours())
		// 	_to.setMinutes(this.periodto.getMinutes())
		// 	_to.setSeconds(0)
		// 	_to.setMilliseconds(0)

		// 	this.periodfrom = _from
		// 	this.periodto = _to
		// }

		FlexEvent.prototype.hasAdvancedSettings = function () {
			return (this.hasPeriod() || (this.getWeekdays() > 0));
		};

		FlexEvent.prototype.toBody = function () {
			return {
				c4api_id: this.c4api_id,
				uuid: this.getUuid(),
				active: this.isActive(),
				weekdays: this.getWeekdays(),
				periodfrom: this.getPeriodFromAsFlexHMS(),
				periodto: this.getPeriodToAsFlexHMS(),
				locale: this.getLocale(),
				text: this.getText(),
				high: this.high ? 1 : 0,
				low: this.low ? 1 : 0,
				type: this.getEventType(),
				min_temp: this.getMinTemperature() * 10,
				max_temp: this.getMaxTemperature() * 10,
				min_humid: this.getMinHumidity(),
				max_humid: this.getMaxHumidity(),
				measure_port: this.getMeasurePort(),
				min_distance: this.getMinDistance(),
				max_distance: this.getMaxDistance(),
				moved_distance: this.getMovedDistance(),
				product: this.product,
				eventHandlerHasEmail: this.getEventHandlerHasEmail()
			}
		};

		/**
		 * Convert ana to distance
		 * @param {number} ana
		 * @param {Features} features
		 * @returns {undefined|number}
		 */
		function anaToDistance(ana, features) {
			if (!angular.isDefined(ana))
				return undefined;

			return features.calcDistance(ana);
		}

		/**
		 *
		 * @param {string} hm_string
		 * @returns {Date|null}
		 */
		function getMomentFromHM(hm_string) {
			var hm = hm_string.split(/[.:\W]/),
				_d = moment()

			if (!isNaN(hm[0]) && !isNaN(hm[0])) {
				_d.hours(hm[0])
				_d.minutes(hm[1])
				return _d
			}

			return undefined;
		}

		function getLocalHMFromHMS(hms_string) {
			if (!hms_string)
				return undefined;

			var hrs = hms_string.substr(0, 2),
				min = hms_string.substr(2, 2),
				_d = moment().utc();
			
			if (!isNaN(hrs) && !isNaN(min)) {
				_d.hours(hrs)
				_d.minutes(min)
				var res = moment().tz() ? _d.tz(moment().tz()) : _d.local()

				return res.format('HH:mm')
			}

			return undefined;
		}

		function lpad(num) {
			return ("0" + num).slice(-2);
		}

		function validatePeriod(period) {
			var hm = period.split(/[.:\W]/),
				hrs = parseInt(hm[0], 10),
				mins = parseInt(hm[1], 10);

			if ((hrs >= 0 && hrs <= 23) && (mins >= 0 && mins <= 59)) {
				return true
			}

			return false
		}

		return FlexEvent;
	}
})();
